module.exports = __webpack_public_path__ + "static/img/jdy2.667a07a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jdy2.png
// module id = oVqy
// module chunks = 0